






import { Component, Vue } from 'vue-property-decorator'
import { UserAPI } from '@/api/backend-client'
import { CompanyAPI } from '@/api/backend-client'

@Component
export default class UserLogout extends Vue {
    async mounted() {
        await UserAPI.logout()
        await CompanyAPI.logout()

        this.$nextTick(() => {
            this.$router.push({
                name: 'dashboard',
            })
        })
    }
}
